import { render, staticRenderFns } from "./LandingAgreementsList.vue?vue&type=template&id=6b0664cc&"
import script from "./LandingAgreementsList.vue?vue&type=script&lang=js&"
export * from "./LandingAgreementsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports